<template>
  <div class="m-search-form">
    <div class="relative">
      <div class="input-container">
        <i :class="['icon-loupe', {'-active': isInputFocus}]" />
        <label
          v-if="inputLabel"
          class="_screenreader-readable"
          for="search-input"
        >
          <span>{{ inputLabel }}</span>
        </label>
        <input
          id="search-input"
          ref="inputSearch"
          name="q"
          autocomplete="off"
          :type="inputType"
          maxlength="256"
          :placeholder="placeholder"
          v-model="query"
          @input="handlers.inputChange"
          @keyup.enter="onEnterKeyPressed"
          @focus="isInputFocus = true"
          @blur="isInputFocus = false"
        >
        <template v-if="query">
          <label
            v-if="inputLabel"
            class="_screenreader-readable"
            for="reset-query-button"
          >
            {{ i18n[locale].resetQuery.accessibilityLabel }}
          </label>
          <button
            id="reset-query-button"
            @click="resetQuery"
            class="reset"
            role="button"
            type="reset"
          >
            <i class="icon-delete-o" />
          </button>
        </template>
      </div>
      <div :class="['m-loading-bar', { '-loading': loading }]">
        <div class="loading-container">
          <div class="loading-gradient-container">
            <div class="loading-gradient" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import enTranslations from './../../../i18n/en_CA/search-form.json'
import frTranslations from './../../../i18n/fr_CA/search-form.json'
import debounce from 'lodash/debounce'

export default {
  name: 'SearchForm',
  props: {
    locale: {
      type: String,
      default: 'en'
    },
    forceQuery: {
      type: String,
      default: ''
    },
    changeDelay: {
      type: Number,
      default: 500
    },
    loading: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Search'
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    inputType: {
      type: String,
      default: 'text'
    },
    inputLabel: {
      type: String,
      default: undefined
    }
  },
  data () {
    return {
      query: '',
      isInputFocus: false,
      handlers: {
        inputChange: debounce(this.onSearchInputChange, this.changeDelay)
      },
      i18n: {
        en: enTranslations,
        fr: frTranslations
      }
    }
  },
  watch: {
    forceQuery: {
      immediate: true,
      handler () {
        if (this.forceQuery && this.forceQuery !== this.query) {
          this.query = this.forceQuery
        }
      }
    }
  },
  mounted () {
    if (this.autofocus) {
      this.$nextTick(function () {
        this.triggerFocus()
      })
    }
  },
  methods: {
    triggerFocus () {
      this.$refs.inputSearch.focus()
    },
    triggerBlur () {
      this.$refs.inputSearch.blur()
    },
    onEnterKeyPressed () {
      this.triggerBlur()
      this.onSearchInputChange()
    },
    onSearchInputChange () {
      if (this.query) {
        this.$emit('onChange', this.query)
      } else {
        this.resetQuery()
      }
    },
    resetQuery () {
      this.query = ''
      this.$emit('onReset')
    }
  }
}
</script>

<style lang="less">
@import "./../../../less/accessibility.less";
@import (reference) "./../../../less/shared/utilities.less";
@import "@{frontend_static_less}/public/modules/m-search-form.less";
@import "@{frontend_static_less}/public/modules/m-loading-bar.less";
</style>
